import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarMnt from '../NewAdminPanel/Common/AdminSidebarMnt';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import { useNavigate, useLocation } from "react-router-dom";

const FmttiSurveyorCreation = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    
    // Basic user information
    const [userNameValue, setUserNameValue] = useState("");
    const [mobileValue, setMobileValue] = useState("");
    const [emailValue, setEmailValue] = useState("");
    const [designationValue, setDesignationValue] = useState("");
    const [gender, setGender] = useState('');
    const [userCodeLocal, setUserCodeLocal] = useState("");
    
    // State and District related
    const [stateValue, setStateValue] = useState("");
    const [districtValue, setDistrictValue] = useState("");
    const [selectedState, setSelectedState] = useState(null);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    
    // Data arrays
    const [statesData, setStatesData] = useState([]);
    const [districtsData, setDistrictsData] = useState([]);
    const [designationData, setDesignationData] = useState([]);

    // Initialize FMTTI and FMTC data from session storage
    const initialData = useMemo(() => {
        const loginData = JSON.parse(sessionStorage.getItem("userData") || "{}");
        
        // Get FMTTI data
        const fmttiCode = sessionStorage.getItem("fmttiCode") || (loginData.fmttiCode ? loginData.fmttiCode.toString() : null);
        const fmttiName = sessionStorage.getItem("fmttiName") || loginData.fmttiName;
      //  alert(sessionStorage.getItem("fmtcCode"))
        // Get FMTC data - check multiple sources and ensure proper type conversion
        const fmtcCode = sessionStorage.getItem("fmtcCode") || 
                        (loginData.fmtcCode ? loginData.fmtcCode.toString() : null) || 
                        (loginData.fmtc_code ? loginData.fmtc_code.toString() : null);
        
        const fmtcName = sessionStorage.getItem("fmtcName") || 
                        sessionStorage.getItem("fmtcUserName") || 
                        loginData.fmtcName || 
                        loginData.fmtc_name;
        
        // Store the data in sessionStorage if we found it in loginData but not in session
        if (fmttiCode && !sessionStorage.getItem("fmttiCode")) {
            sessionStorage.setItem("fmttiCode", fmttiCode);
        }
        if (fmttiName && !sessionStorage.getItem("fmttiName")) {
            sessionStorage.setItem("fmttiName", fmttiName);
        }
        if (fmtcCode && !sessionStorage.getItem("fmtcCode")) {
            sessionStorage.setItem("fmtcCode", fmtcCode);
        }
        if (fmtcName && !sessionStorage.getItem("fmtcName") && !sessionStorage.getItem("fmtcUserName")) {
            sessionStorage.setItem("fmtcName", fmtcName);
        }
        
        // Debug logging
        console.log("FMTC Debug - Session Storage Values:", {
            fmtcCode: sessionStorage.getItem("fmtcCode"),
            fmtcName: sessionStorage.getItem("fmtcName"),
            fmtcUserName: sessionStorage.getItem("fmtcUserName"),
            fmttiCode: sessionStorage.getItem("fmttiCode"),
            fmttiName: sessionStorage.getItem("fmttiName"),
            loginData: loginData
        });
        
        console.log("FMTC Debug - Final Values:", {
            fmttiCode,
            fmttiName,
            fmtcCode,
            fmtcName
        });
        
        return {
            fmttiData: fmttiCode && fmttiName ? [{
                fmtticode: fmttiCode,
                fmttiname: fmttiName
            }] : [],
           
            fmtcData: fmtcCode && fmtcName ? [{
                fmtccode: fmtcCode,
                fmtcname: fmtcName
            }] : [],
            selectedFmtti: fmttiCode || "",
            selectedFmtc: fmtcCode || ""
        };
    }, []);

    // State declarations
    const [fmttiData, setFmttiData] = useState(initialData.fmttiData);
    const [fmtcData, setFmtcData] = useState(initialData.fmtcData);
    const [selectedFmtti, setSelectedFmtti] = useState(initialData.selectedFmtti);
    const [selectedFmtc, setSelectedFmtc] = useState(initialData.selectedFmtc);

    // Helper function to ensure sessionStorage is properly populated
    const ensureSessionStorage = () => {
        const loginData = JSON.parse(sessionStorage.getItem("loginData") || "{}");
        
        // Ensure FMTTI data is stored
        if (loginData.fmttiCode && !sessionStorage.getItem("fmttiCode")) {
            sessionStorage.setItem("fmttiCode", loginData.fmttiCode.toString());
        }
        if (loginData.fmttiName && !sessionStorage.getItem("fmttiName")) {
            sessionStorage.setItem("fmttiName", loginData.fmttiName);
        }
        
        // Ensure FMTC data is stored
        if (loginData.fmtcCode && !sessionStorage.getItem("fmtcCode")) {
            sessionStorage.setItem("fmtcCode", loginData.fmtcCode.toString());
        }
        if (loginData.fmtcName && !sessionStorage.getItem("fmtcName") && !sessionStorage.getItem("fmtcUserName")) {
            sessionStorage.setItem("fmtcName", loginData.fmtcName);
        }
        
        return {
            fmttiCode: sessionStorage.getItem("fmttiCode"),
            fmttiName: sessionStorage.getItem("fmttiName"),
            fmtcCode: sessionStorage.getItem("fmtcCode"),
            fmtcName: sessionStorage.getItem("fmtcName") || sessionStorage.getItem("fmtcUserName")
        };
    };

    useEffect(() => {
        const userCode = sessionStorage.getItem("userCodeModel");
        const userName = sessionStorage.getItem("userNameModel");
        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        
        if (!userCode || !userName || !schemeCode) {
            navigate("/mapLogin");
            return;
        }

        // Ensure sessionStorage is properly populated from loginData
        const sessionData = ensureSessionStorage();
        
        // Set FMTTI data if available
        if (sessionData.fmttiCode && sessionData.fmttiName) {
            setSelectedFmtti(sessionData.fmttiCode);
            setFmttiData([{ fmtticode: sessionData.fmttiCode, fmttiname: sessionData.fmttiName }]);
        }

        // Set FMTC data if available, otherwise fetch it
        if (sessionData.fmtcCode && sessionData.fmtcName) {
            setSelectedFmtc(sessionData.fmtcCode);
            setFmtcData([{ fmtccode: sessionData.fmtcCode, fmtcname: sessionData.fmtcName }]);
        } else if (sessionData.fmttiCode) {
            // If we have fmttiCode but not fmtcCode/fmtcName, fetch FMTC data
            fetchFmtc(sessionData.fmttiCode);
        }

        // Removed auto-fill of userName on page load
        // if (userName && !state) {
        //     setUserNameValue(userName);
        // }

        fetchStates();
        fetchDesignation();
    }, [navigate]);

    useEffect(() => {
        if (stateValue && stateValue !== "NA" && stateValue !== "") {
            fetchDistricts(stateValue);
        } else {
            setDistrictsData([]);
            if (!state && districtValue !== "") {
                setDistrictValue("");
            }
        }
    }, [stateValue]);

    useEffect(() => {
        if (state) {
            setUserNameValue(state.cropSurveyCode.userName);
            setMobileValue(state.cropSurveyCode.mobile);
            setEmailValue(state.cropSurveyCode.emailId || "");
            setDesignationValue(state.cropSurveyCode.designationCode);
            setUserCodeLocal(state.cropSurveyCode.userCode);
            setGender(state.cropSurveyCode.gender);
            setStateValue(state.cropSurveyCode.stateCode);
            setDistrictValue(state.cropSurveyCode.districtCode);
            
            if (statesData.length > 0 && state.cropSurveyCode.stateCode) {
                const selectedStateObj = statesData.find(s => s.stateCode.toString() === state.cropSurveyCode.stateCode.toString());
                if (selectedStateObj) {
                    setSelectedState(selectedStateObj);
                }
            }
            
            if (districtsData.length > 0 && state.cropSurveyCode.districtCode) {
                const selectedDistrictObj = districtsData.find(d => d.districtCode.toString() === state.cropSurveyCode.districtCode.toString());
                if (selectedDistrictObj) {
                    setSelectedDistrict(selectedDistrictObj);
                }
            }
        }
    }, [statesData, districtsData]);

    useEffect(() => {
        if (stateValue && stateValue !== "NA" && !selectedState && statesData.length > 0) {
            const selectedStateObj = statesData.find(s => s.stateCode.toString() === stateValue.toString());
            if (selectedStateObj) {
                setSelectedState(selectedStateObj);
            }
        }
    }, [stateValue, statesData, selectedState]);

    useEffect(() => {
        if (districtValue && districtValue !== "NA" && !selectedDistrict && districtsData.length > 0) {
            const selectedDistrictObj = districtsData.find(d => d.districtCode.toString() === districtValue.toString());
            if (selectedDistrictObj) {
                setSelectedDistrict(selectedDistrictObj);
            }
        }
    }, [districtValue, districtsData, selectedDistrict]);

    // New useEffect to handle FMTC auto-selection
    useEffect(() => {
        const handleFmtcSelection = () => {
            const loginData = JSON.parse(sessionStorage.getItem("loginData") || "{}");
            const storedFmtcCode = sessionStorage.getItem("fmtcCode");
            const storedFmtcName = sessionStorage.getItem("fmtcName") || sessionStorage.getItem("fmtcUserName");
            
            // If we have loginData with fmtcCode and fmtcName, use them directly
            if (loginData.fmtcCode && loginData.fmtcName) {
                console.log("Auto-selecting FMTC from loginData:", {
                    fmtcCode: loginData.fmtcCode,
                    fmtcName: loginData.fmtcName
                });
                
                setSelectedFmtc(loginData.fmtcCode.toString());
                setFmtcData([{
                    fmtccode: loginData.fmtcCode.toString(),
                    fmtcname: loginData.fmtcName
                }]);
                
                // Store in session storage
                sessionStorage.setItem("fmtcCode", loginData.fmtcCode.toString());
                sessionStorage.setItem("fmtcName", loginData.fmtcName);
            } else if (storedFmtcCode && storedFmtcName) {
                console.log("Auto-selecting FMTC from session storage:", {
                    fmtcCode: storedFmtcCode,
                    fmtcName: storedFmtcName
                });
                
                setSelectedFmtc(storedFmtcCode);
                setFmtcData([{
                    fmtccode: storedFmtcCode,
                    fmtcname: storedFmtcName
                }]);
            } else if (selectedFmtti && fmtcData.length === 0) {
                // If we have FMTTI but no FMTC data, fetch it
                console.log("Fetching FMTC data for FMTTI:", selectedFmtti);
                fetchFmtc(selectedFmtti);
            }
        };
        
        // Run the selection logic after a short delay to ensure all data is loaded
        setTimeout(handleFmtcSelection, 100);
    }, [selectedFmtti, fmtcData.length]);

    const fetchDesignation = async () => {
        try {
            const result = await axios(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/Management/commDesignation`
            );
            setDesignationData(result.data.dataContent);
        } catch (error) {
            console.error("Error fetching designations:", error);
        }
    };

    const fetchStates = async () => {
        try {
            const result = await axios(
                `${
                    process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                }/api/states`
            );
            setStatesData(result.data.dataContent);
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    };

    const fetchDistricts = async (stateCode) => {
        try {
            const response = await fetch(
                `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/district`, 
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ stateCode: Number(stateCode) })
                }
            );
            
            const result = await response.json();
            
            if (result?.dataContent && Array.isArray(result.dataContent)) {
                const validDistricts = result.dataContent.filter(district => 
                    district.districtCode && district.districtName
                );
                setDistrictsData(validDistricts);
            } else {
                setDistrictsData([]);
                setDistrictValue("NA");
            }
        } catch (error) {
            setDistrictsData([]);
            setDistrictValue("NA");
        }
    };

    const fetchFmtc = async (fmtticode = "0") => {
        try {
            console.log("Fetching FMTC data for FMTTI code:", fmtticode);
            
            // Validate fmtticode
            if (!fmtticode || fmtticode === "0" || fmtticode === "null" || fmtticode === "undefined") {
                console.error("Invalid FMTTI code for fetching FMTC:", fmtticode);
                return;
            }
            
            const payload = {
                fmtccode: 0,
                fmtcname: "",
                fmtticode: Number(fmtticode)
            };
            
            console.log("FMTC API Request payload:", payload);
            
            const response = await axios.post(
                `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetFmtc`, 
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }
            );
            
            console.log("FMTC API response:", response.data);
            
            if (response.data?.success && response.data.dataContent) {
                const fmtcList = response.data.dataContent;
                
                if (Array.isArray(fmtcList) && fmtcList.length > 0) {
                    const fmtcDataArray = fmtcList
                        .filter(item => item.fmtcCode || item.fmtccode)
                        .map(item => ({
                            fmtccode: (item.fmtcCode || item.fmtccode || "").toString(),
                            fmtcname: item.fmtcName || item.fmtcname || ""
                        }));
                    
                    console.log("FMTC data loaded successfully:", fmtcDataArray);
                    setFmtcData(fmtcDataArray);
                    
                    // Get stored FMTC data from session storage and loginData
                    const storedFmtcCode = sessionStorage.getItem("fmtcCode");
                    const storedFmtcName = sessionStorage.getItem("fmtcName") || sessionStorage.getItem("fmtcUserName");
                    const loginData = JSON.parse(sessionStorage.getItem("loginData") || "{}");
                    
                    console.log("FetchFmtc - Available FMTC Data:", fmtcDataArray);
                    console.log("FetchFmtc - Stored Values:", {
                        storedFmtcCode,
                        storedFmtcName,
                        loginDataFmtcCode: loginData.fmtcCode,
                        loginDataFmtcName: loginData.fmtcName
                    });
                    
                    // Try to find matching FMTC in multiple ways
                    let matchingFmtc = null;
                    
                    // First try: Match by fmtcCode
                    if (storedFmtcCode) {
                        matchingFmtc = fmtcDataArray.find(item => item.fmtccode === storedFmtcCode);
                    }
                    
                    // Second try: Match by fmtcCode from loginData
                    if (!matchingFmtc && loginData.fmtcCode) {
                        matchingFmtc = fmtcDataArray.find(item => item.fmtccode === loginData.fmtcCode.toString());
                    }
                    
                    // Third try: Match by fmtcName (partial match)
                    if (!matchingFmtc && storedFmtcName) {
                        matchingFmtc = fmtcDataArray.find(item => 
                            item.fmtcname && item.fmtcname.toLowerCase().includes(storedFmtcName.toLowerCase())
                        );
                    }
                    
                    // Fourth try: Match by fmtcName from loginData (partial match)
                    if (!matchingFmtc && loginData.fmtcName) {
                        matchingFmtc = fmtcDataArray.find(item => 
                            item.fmtcname && item.fmtcname.toLowerCase().includes(loginData.fmtcName.toLowerCase())
                        );
                    }
                    
                    // If we found a matching FMTC, select it
                    if (matchingFmtc) {
                        console.log("FetchFmtc - Found matching FMTC:", matchingFmtc);
                        setSelectedFmtc(matchingFmtc.fmtccode);
                        
                        // Update session storage with the correct values
                        sessionStorage.setItem("fmtcCode", matchingFmtc.fmtccode);
                        sessionStorage.setItem("fmtcName", matchingFmtc.fmtcname);
                    } else if (fmtcDataArray.length === 1) {
                        // If only one FMTC option, auto-select it
                        console.log("FetchFmtc - Auto-selecting single FMTC:", fmtcDataArray[0]);
                        setSelectedFmtc(fmtcDataArray[0].fmtccode);
                        sessionStorage.setItem("fmtcCode", fmtcDataArray[0].fmtccode);
                        sessionStorage.setItem("fmtcName", fmtcDataArray[0].fmtcname);
                    } else {
                        console.log("FetchFmtc - No matching FMTC found, available options:", fmtcDataArray);
                    }
                } else {
                    console.error("FMTC data is empty or invalid format");
                    setFmtcData([]);
                }
            } else {
                console.error("Invalid FMTC API response format");
                setFmtcData([]);
            }
        } catch (error) {
            console.error("Error fetching FMTC data:", error);
            setFmtcData([]);
            if (error.response) {
                console.error("Error response:", error.response.data);
                console.error("Error status:", error.response.status);
            }
        }
    };

    const getCurrentDate = () => {
        const now = new Date();
        return now.toISOString();
    };

    function ValidateAddUser() {
        if (!selectedFmtti || selectedFmtti === "NA") {
            alert("Please select an FMTTI");
            return false;
        }

        if (!selectedFmtc || selectedFmtc === "NA") {
            alert("Please select an FMTC");
            return false;
        }

        if (!stateValue || stateValue === "NA" || stateValue === "0" || stateValue === "") {
            alert("Please select a state");
            return false;
        }

        if (!districtValue || districtValue === "NA" || districtValue === "0" || districtValue === "") {
            alert("Please select a district");
            return false;
        }

        if (!userNameValue || userNameValue.trim() === "") {
            alert("Please enter a valid user name");
            return false;
        }

        if (!designationValue || designationValue === "Choose..." || designationValue === "") {
            alert("Please select a designation");
            return false;
        }

        if (!mobileValue || mobileValue.length !== 10) {
            alert("Please enter a valid 10-digit mobile number");
            return false;
        }
        // Email validation
            if(emailValue === "" || emailValue.length < 5 || !validateEmail(emailValue)) {
                alert("Please enter a valid Email ID");
                return;
            }
            // Gender validation
            if(gender === "") {
                alert("Please select a gender");
                return;
            }
        if (!gender) {
            alert("Please select a gender");
            return false;
        }

        if (emailValue && !validateEmail(emailValue)) {
            alert("Please enter a valid email address");
            return false;
        }

        state ? UpdateUser() : AddNewUser();
        return true;
    }

    function validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    function AddNewUser() {
        try {
            if (!stateValue || stateValue === "NA" || stateValue === "0") {
                alert("Please select a valid State");
                return;
            }
            if (!districtValue || districtValue === "NA" || districtValue === "0") {
                alert("Please select a valid District");
                return;
            }

            const selectedState = statesData.find(s => s.stateCode.toString() === stateValue.toString());
            const selectedDistrict = districtsData.find(d => d.districtCode.toString() === districtValue.toString());

            if (!selectedState) {
                alert("Please ensure a valid state is selected");
                return;
            }

            if (!selectedDistrict) {
                alert("Please ensure a valid district is selected");
                return;
            }

            const userCode = sessionStorage.getItem("userCodeModel");
            if (!userCode) {
                alert("Session expired. Please login again.");
                navigate("/mapLogin");
                return;
            }

            const payload = {
                "entity": "user",
                "createdOnByUC": getCurrentDate(),
                "createdByUC": Number(sessionStorage.getItem("userCodeModel")),
                "modifiedOnByUC": null,
                "modifiedByUC": Number(sessionStorage.getItem("userCodeModel")),
                "userRoleCode": "8",
                "userCode": 0,
                "userName": userNameValue.trim(),
                "userId": mobileValue,
                "mobile": mobileValue,
                "password": "",
                "passwordNew": "",
                "passwordConfirm": "",
                "emailId": emailValue ? emailValue.trim() : "",
                "gender": gender,
                "aadhar": "",
                "departmentCode": "1",
                "designationCode":String(designationValue),
                "stateCode": String(selectedState.stateCode),
                "stateName": String(selectedState.stateName),
                "districtCode":  String(selectedDistrict.districtCode),
                "districtName": String(selectedDistrict.districtName),
                "subDistrictCode": "0",
                "blockCode": "0",
                "villageCode": "",
                "userTypeCode": "1",
                "schemeCode": "16",
                "isVisible": "Y",
                "isActive": "Y",
                "lastLoginOn": null,
                "otp": "",
                "custumMessage": "",
                "isMobileVerified": "N",
                "isEmailVerified": "N",
                "orgTypeCode": "1",
                "insuranceCompanyCode": "",
                "fmttiCode": String(selectedFmtti),
                "fmtcCode": String(selectedFmtc),
                "atariCode": "0",
                "kvkCode": "0",
                "states": null
            };

            fetch(`${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Users`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            })
            .then(async (response) => {
                const text = await response.text();
                return { status: response.status, data: text };
            })
            .then(({ status, data }) => {
                try {
                    const jsonResult = JSON.parse(data);
                    if (jsonResult.success === true) {
                        alert("FMTTI Surveyor created successfully!");
                        
                        const currentUserCode = sessionStorage.getItem("userCodeModel");
                        const currentUserRole = sessionStorage.getItem("userRoleCodeModel");
                        
                        if (currentUserCode && currentUserCode !== "null" && currentUserCode !== "undefined") {
                            sessionStorage.setItem("createdByUCModel", currentUserCode);
                        } else {
                            sessionStorage.setItem("createdByUCModel", "1");
                            sessionStorage.setItem("userCodeModel", "1");
                        }
                        
                        if (currentUserRole && currentUserRole !== "null" && currentUserRole !== "undefined") {
                            sessionStorage.setItem("userTypeCodeModel", currentUserRole);
                        } else {
                            sessionStorage.setItem("userTypeCodeModel", "8");
                            sessionStorage.setItem("userRoleCodeModel", "8");
                        }
                        
                        sessionStorage.setItem("schemeCode", "16");
                        navigate("/MNT/UsrListMnT");
                    } else {
                        // Handle specific error messages
                        let errorMessage = "Failed to create FMTTI Surveyor user.";
                        
                        if (jsonResult.message) {
                            if (jsonResult.message.includes("Mobile already exist")) {
                                errorMessage = "A user with this mobile number already exists. Please use a different mobile number.";
                            } else if (jsonResult.message.includes("Email already exist")) {
                                errorMessage = "A user with this email address already exists. Please use a different email address.";
                            } else if (jsonResult.message.includes("User already exist")) {
                                errorMessage = "A user with this information already exists. Please check the details and try again.";
                            } else {
                                errorMessage = jsonResult.message;
                            }
                        }
                        
                        alert(errorMessage);
                    }
                } catch (error) {
                    alert("Error processing server response. Please try again.");
                }
            })
            .catch((error) => {
                if (error.message === "Failed to fetch") {
                    alert("Unable to connect to server. Please check your internet connection and try again.");
                } else {
                    alert("Error communicating with server: " + error.message);
                }
            });
        } catch (error) {
            alert("An error occurred while creating user. Please check console for details.");
        }
    }

    function UpdateUser() {
        try {
            if (!stateValue || stateValue === "NA" || stateValue === "0") {
                alert("Please select a valid State");
                return;
            }
            if (!districtValue || districtValue === "NA" || districtValue === "0") {
                alert("Please select a valid District");
                return;
            }

            const selectedState = statesData.find(s => s.stateCode.toString() === stateValue.toString());
            const selectedDistrict = districtsData.find(d => d.districtCode.toString() === districtValue.toString());

            if (!selectedState) {
                alert("Please ensure a valid state is selected");
                return;
            }

            if (!selectedDistrict) {
                alert("Please ensure a valid district is selected");
                return;
            }

            const payload = {
                "createdOnByUC": getCurrentDate(),
                "createdByUC": Number(sessionStorage.getItem("userCodeModel")),
                "modifiedOnByUC": getCurrentDate(),
                "modifiedByUC": Number(sessionStorage.getItem("userCodeModel")),
                "userRoleCode": "8",
                "userCode": Number(userCodeLocal),
                "userName": userNameValue.trim(),
                "userId": mobileValue,
                "mobile": mobileValue,
                "password": "",
                "passwordNew": "",
                "passwordConfirm": "",
                "emailId": emailValue ? emailValue.trim() : "",
                "gender": gender,
                "aadhar": "",
                "departmentCode": "1",
                "designationCode": String(designationValue),
                "stateCode": String(selectedState.stateCode),
                "stateName": String(selectedState.stateName),
                "districtCode": String(selectedDistrict.districtCode),
                "districtName": String(selectedDistrict.districtName),
                "subDistrictCode": "0",
                "blockCode": "0",
                "villageCode": "",
                "userTypeCode": "1",
                "schemeCode": "16",
                "isVisible": "Y",
                "isActive": "Y",
                "lastLoginOn": getCurrentDate(),
                "otp": "",
                "custumMessage": "",
                "isMobileVerified": "N",
                "isEmailVerified": "N",
                "orgTypeCode": "1",
                "insuranceCompanyCode": "",
                "fmttiCode": String(selectedFmtti),
                "fmtcCode": String(selectedFmtc),
                "atariCode": "0",
                "kvkCode": "0",
                "states": null
            };

            fetch(`${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/Users`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            })
            .then((response) => response.text())
            .then((result) => {
                try {
                    const jsonResult = JSON.parse(result);
                    
                    if (jsonResult.success === true) {
                        alert("FMTTI Surveyor updated successfully!");
                        
                        const currentUserCode = sessionStorage.getItem("userCodeModel");
                        const currentUserRole = sessionStorage.getItem("userRoleCodeModel");
                        
                        if (currentUserCode && currentUserCode !== "null" && currentUserCode !== "undefined") {
                            sessionStorage.setItem("createdByUCModel", currentUserCode);
                        } else {
                            sessionStorage.setItem("createdByUCModel", "1");
                            sessionStorage.setItem("userCodeModel", "1");
                        }
                        
                        if (currentUserRole && currentUserRole !== "null" && currentUserRole !== "undefined") {
                            sessionStorage.setItem("userTypeCodeModel", currentUserRole);
                        } else {
                            sessionStorage.setItem("userTypeCodeModel", "8");
                            sessionStorage.setItem("userRoleCodeModel", "8");
                        }
                        
                        sessionStorage.setItem("schemeCode", "16");
                        navigate("/MNT/UsrlistMnT");
                    } else {
                        // Handle specific error messages
                        let errorMessage = "Failed to update FMTTI Surveyor user.";
                        
                        if (jsonResult.message) {
                            if (jsonResult.message.includes("Mobile already exist")) {
                                errorMessage = "A user with this mobile number already exists. Please use a different mobile number.";
                            } else if (jsonResult.message.includes("Email already exist")) {
                                errorMessage = "A user with this email address already exists. Please use a different email address.";
                            } else if (jsonResult.message.includes("User already exist")) {
                                errorMessage = "A user with this information already exists. Please check the details and try again.";
                            } else {
                                errorMessage = jsonResult.message;
                            }
                        }
                        
                        alert(errorMessage);
                    }
                } catch (error) {
                    alert("Error processing server response. Please try again.");
                }
            })
            .catch((error) => {
                if (error.message === "Failed to fetch") {
                    alert("Unable to connect to server. Please check your internet connection and try again.");
                } else {
                    alert("Error communicating with server: " + error.message);
                }
            });
        } catch (error) {
            alert("An error occurred while updating user. Please check console for details.");
        }
    }

    function handleMobileNumber(value) {
        const valueFinal = value.replace(/\D/g, "").replace(/^0/, "").replace(/^1/, "").replace(/^2/, "").replace(/^3/, "").replace(/^4/, "").replace(/^5/, "");
        setMobileValue(valueFinal)
    }

    function validateMobile() {
        if (mobileValue.length === 10) {
            document.getElementById("mobilenumber").style.borderColor = "green";
        } else {
            document.getElementById("mobilenumber").style.borderColor = "red";
        }
    }

    function handleUserName(e) {
        setUserNameValue(e.target.value);
    }

    function handleEmail(e) {
        setEmailValue(e.target.value);
    }

    const handleStateChange = (e) => {
        const value = e.target.value;
        
        if (value && value !== "NA") {
            const selectedStateObj = statesData.find(s => s.stateCode.toString() === value.toString());
            
            if (selectedStateObj) {
                setStateValue(value);
                setSelectedState(selectedStateObj);
                setDistrictValue("");
                setSelectedDistrict(null);
                fetchDistricts(value);
            } else {
                alert("Error: Selected state not found. Please try again.");
            }
        } else {
            setStateValue("");
            setSelectedState(null);
            setDistrictValue("");
            setSelectedDistrict(null);
            setDistrictsData([]);
        }
    };

    const handleDistrictChange = (e) => {
        const value = e.target.value;
        
        if (value && value !== "NA") {
            const selectedDistrictObj = districtsData.find(d => d.districtCode.toString() === value.toString());
            
            if (selectedDistrictObj) {
                setDistrictValue(value);
                setSelectedDistrict(selectedDistrictObj);
            } else {
                alert("Error: Selected district not found. Please try again.");
            }
        } else {
            setDistrictValue("");
            setSelectedDistrict(null);
        }
    };

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarMnt /> 
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>FMTTI-Surveyor Creation</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Admin</li>
                            <li className="breadcrumb-item active">FMTTI-Surveyor Creation</li>
                            <li className="breadcrumb-item">{(sessionStorage.getItem("userNameModel"))}</li>
                        </ol>
                    </nav>
                </div>
                
               

                {/* Additional debug info */}
                
                <section className="section dashboard newAdminForms">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row'>
                                        
                                        {/* FMTTI Selection */}
                                        <div className='col-md-4'>
                                            <label className="form-label">FMTTI</label><label style={{color : "red"}}>*</label>
                                            <select 
                                                className='form-select' 
                                                value={selectedFmtti || "NA"}
                                                disabled
                                            > 
                                                <option value="NA">Choose...</option>
                                                {fmttiData.map((item, id) => (
                                                    <option key={id} value={item.fmtticode}>
                                                        {item.fmttiname}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        
                                        {/* FMTC Selection */}
                                        <div className='col-md-4'>
                                            <label className="form-label">FMTC</label><label style={{color : "red"}}>*</label>
                                            <select 
                                                className='form-select' 
                                                value={selectedFmtc || "NA"}
                                               
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    console.log("FMTC selected:", value);
                                                    setSelectedFmtc(value);
                                                    
                                                    // Update session storage
                                                    if (value && value !== "NA") {
                                                        const selectedFmtcObj = fmtcData.find(item => item.fmtccode === value);
                                                        if (selectedFmtcObj) {
                                                            sessionStorage.setItem("fmtcCode", value);
                                                            sessionStorage.setItem("fmtcName", selectedFmtcObj.fmtcname);
                                                        }
                                                    }
                                                }}
                                                disabled={state ? true : true}
                                            > 
                                                <option value="NA">Choose...</option>
                                                {fmtcData && fmtcData.length > 0 && fmtcData.map((item, id) => (
                                                    <option key={id} value={item.fmtccode}>
                                                        {item.fmtcname}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        
                                        {/* State Name */}
                                        <div className='col-md-4'>
                                            <label className="form-label">State Name</label><label style={{color : "red"}}>*</label>
                                            <select 
                                                className='form-select' 
                                                value={stateValue || "NA"}
                                                onChange={handleStateChange}
                                            > 
                                                <option value="NA">Choose...</option>
                                                {statesData.map((item) => (
                                                    <option key={item.stateCode} value={item.stateCode}>
                                                        {item.stateName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        
                                        {/* District Name */}
                                        <div className='col-md-4'>
                                            <label className="form-label">District Name</label><label style={{color : "red"}}>*</label>
                                            <select 
                                                className='form-select' 
                                                value={districtValue || "NA"}
                                                onChange={handleDistrictChange}
                                                disabled={!stateValue || stateValue === "NA"}
                                            >
                                                <option value="NA">Choose...</option>
                                                {districtsData.map((item) => (
                                                    <option key={item.districtCode} value={item.districtCode}>
                                                        {item.districtName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        
                                        {/* User Name */}
                                        <div className='col-md-4'>
                                            <label className="form-label">User Name</label><label style={{color : "red"}}>*</label>
                                            <input 
                                                placeholder='User Name' 
                                                type='text' 
                                                className='form-control' 
                                                onChange={(e) => handleUserName(e)} 
                                                value={userNameValue} 
                                                maxLength={50} 
                                                readOnly={state ? true : false}
                                                autoComplete="off"
                                            />
                                        </div>
                                    
                                        {/* Designation */}
                                        <div className="col-md-4">
                                            <label htmlFor="Designation" className="form-label">
                                              Designation
                                            </label><label style={{color : "red"}}>*</label>
                                            <select
                                              id="Designation"
                                              required
                                              className="form-select"
                                              onChange={(e) => setDesignationValue(e.target.value)}
                                              value={designationValue}
                                            >
                                              <option defaultValue>Choose...</option>
                                              {designationData.map((item, id) => {
                                                return (
                                                  <option key={id} value={item.desigCode}>
                                                    {item.desigName}
                                                  </option>
                                                );
                                              })}
                                            </select>
                                        </div>
                                        
                                        {/* Mobile No */}
                                        <div className="col-md-4">
                                            <label htmlFor="mobileNo" className="form-label">
                                              Mobile No
                                            </label><label style={{color : "red"}}>*</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              id="mobilenumber"
                                              required
                                              placeholder="Mobile No."
                                              onChange={(e) => handleMobileNumber(e.target.value)}
                                              value={mobileValue}
                                              onKeyUp={validateMobile}
                                              maxLength="10"
                                              readOnly={state ? true : false}
                                              autoComplete="off"
                                            />
                                        </div>
                                        {/* Email Id */}
                                        <div className="col-md-4">
                                            <label htmlFor="emailId" className="form-label">
                                              Email Id
                                            </label>
                                            <input
                                              type="email"
                                              className="form-control"
                                              id="emailId"
                                              placeholder="Email Id"
                                              onChange={(e) => handleEmail(e)}
                                              value={emailValue}
                                              autoComplete="off"
                                            />
                                        </div>
                                        {/* Gender */}
                                        <div className="col-md-4">
                                            <div className="col-md-12">
                                              <label htmlFor="gender" className="form-label">
                                                Gender
                                              </label><label style={{color : "red"}}>*</label>
                                            </div>
                                            <div className="col-md-12">
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => setGender("M")}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio1"
                                                  value="male"
                                                  checked={gender === "M"}
                                                  onChange={() => {}}
                                                  readOnly
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio1"
                                                >
                                                  Male
                                                </label>
                                              </div>
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => setGender("F")}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio2"
                                                  value="female"
                                                  checked={gender === "F"}
                                                  onChange={() => {}}
                                                  readOnly
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio2"
                                                >
                                                  Female
                                                </label>
                                              </div>
                                              <div
                                                className="form-check form-check-inline"
                                                onClick={() => setGender("T")}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name="gender"
                                                  id="inlineRadio3"
                                                  value="transgender"
                                                  checked={gender === "T"}
                                                  onChange={() => {}}
                                                  readOnly
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor="inlineRadio3"
                                                >
                                                  Other
                                                </label>
                                              </div>
                                            </div>
                                          </div>

                                        
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="d-grid gap-2 d-md-flex justify-content-md-center mt-4">
                                        {state ? (
                                          <button
                                            className="btn btn-success me-md-2"
                                            type="button"
                                            onClick={ValidateAddUser}
                                          >
                                            Update FMTTI Surveyor
                                          </button>
                                        ) : (
                                          <button
                                            className="btn btn-success me-md-2"
                                            type="button"
                                            onClick={ValidateAddUser}
                                          >
                                            Create FMTTI Surveyor
                                          </button>
                                        )}

                                        <button
                                          className="btn btn-outline-danger"
                                          type="button"
                                          onClick={() => navigate("/MNT/UsrlistMnT")}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <AdminFooterNew /> 
        </>
    );
}; 

export default FmttiSurveyorCreation; 